<template>
    <div class="body">
        <div class="content">
            <img src="@/assets/mifi/title4.jpg" style="width: 100%;" />
            <van-tabs @click="onClick">
                <van-tab v-for="index in vanTab" :title="index" :key="index" />
            </van-tabs>
            <mt-loadmore :bottom-method="getAgentPrechargeListHandler" :bottom-all-loaded="allLoaded" :auto-fill="false"
                ref="loadmore">
                <van-row class="el-col-row">
                    <van-col span="12" v-for="item in wifiList" :key="item.id" @click.native="linkOpen(item)">
                        <div class="item-data">
                            <img :src="item.img" alt="" />
                            <div class="goodsTitle">{{ item.shareName }}</div>
                            <div class="goodsPrc">¥{{ item.sharePrice }}</div>
                        </div> 
                    </van-col>
                </van-row>
            </mt-loadmore>
            <div class="copyRight">
                <div style="text-align: center;margin-bottom:14px;">QQ：692217838</div>
                <div style="text-align: center;margin:14px 0;">山东火炬信息技术服务有限公司</div>
                <div style="text-align: center;margin-bottom:14px;">备案号：鲁ICP备2023021273号-1</div>
                <div style="text-align: center;margin-bottom:14px;">地址：山东省济南市市中区大观园街道经五路11号3楼040</div>
            </div>
        </div>
        <div class="f-tab">
            <van-tabbar v-model="active" @change="onChange">
                <van-tabbar-item icon="home-o">首页</van-tabbar-item>
                <van-tabbar-item icon="friends-o">我的</van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog } from "vant";
export default {
    data() {
        return {
            dataList: [
                {
                    img: require('@/assets/mifi/5.png'), //首图
                    imga: require('@/assets/mifi/6.png'),//介绍图
                    imgb: require('@/assets/mifi/7.png'),//介绍图
                    shareName: 'WiFi6全千兆高速AX3000家用路由器5G双频穿墙王全屋覆盖大户型mesh分布式无线漏油器AX12Pro',
                    sharePrice: '88.90',
                    type: '1',
                    title: 'WIFI设备',
                },
                {
                    img: require('@/assets/mifi/8.png'), //首图
                    imga: require('@/assets/mifi/9.png'),//介绍图
                    imgb: require('@/assets/mifi/10.png'),//介绍图
                    shareName: 'TP-LINK 无线路由器 家用高速wifi tplink百兆端口 tp路由器宿舍学生寝室 TL-WR886N',
                    sharePrice: '120.00',
                    type: '1',
                    title: 'WIFI设备',
                },
                {
                    img: require('@/assets/mifi/11.png'), //首图
                    imga: require('@/assets/mifi/12.png'),//介绍图
                    imgb: require('@/assets/mifi/13.png'),//介绍图
                    shareName: 'neiends 2024新款无线路由器 移动软路由千兆高速家用穿墙王wifi6全屋覆盖 宿舍出租屋户外工地 4G插卡路由器',
                    sharePrice: '100.00',
                    type: '1',
                    title: 'WIFI设备',
                },
                {
                    img: require('@/assets/mifi/14.png'), //首图
                    imga: require('@/assets/mifi/15.png'),//介绍图
                    imgb: require('@/assets/mifi/16.png'),//介绍图
                    shareName: '全新千兆华为HS8145V5光猫路由器一体机四口千兆宽带猫无线猫5G猫',
                    sharePrice: '150.90',
                    type: '1',
                    title: 'WIFI设备',
                },
                {
                    img: require('@/assets/mifi/17.png'), //首图
                    imga: require('@/assets/mifi/18.png'),//介绍图
                    imgb: require('@/assets/mifi/19.png'),//介绍图
                    shareName: '光猫路由器一体智能无线路由器家用wifi高速穿墙王大功率千兆双频',
                    sharePrice: '98.00',
                    type: '1',
                    title: 'WIFI设备',
                },
                {
                    img: require('@/assets/mifi/20.png'), //首图
                    imga: require('@/assets/mifi/21.png'),//介绍图
                    imgb: require('@/assets/mifi/22.png'),//介绍图
                    shareName: 'Haohanxin1光2电千兆光纤收发器单模单纤收发器光电转换器A/B端A',
                    sharePrice: '48',
                    type: '1',
                    title: 'WIFI设备',
                },
                {
                    img: require('@/assets/mifi/23.png'), //首图
                    imga: require('@/assets/mifi/24.png'),//介绍图
                    imgb: require('@/assets/mifi/25.png'),//介绍图
                    shareName: 'TP-LINK网线超五类千兆宽带连接 路由监控家用高速网络工程线EC5e',
                    sharePrice: '59.9',
                    type: '1',
                    title: 'WIFI设备',
                },
                {
                    img: require('@/assets/mifi/26.png'), //首图
                    imga: require('@/assets/mifi/27.png'),//介绍图
                    imgb: require('@/assets/mifi/28.png'),//介绍图
                    shareName: '网线家用千兆超6六类5类高速电脑成品路由器连接线宽带网络对接头',
                    sharePrice: '22.99',
                    type: '1',
                    title: 'WIFI设备',
                },
                {
                    img: require('@/assets/mifi/29.png'), //首图
                    imga: require('@/assets/mifi/30.png'),//介绍图
                    imgb: require('@/assets/mifi/31.png'),//介绍图
                    shareName: '百兆千兆2.5g交换机POE交换机监控专用校园网宽带网络交换机网线分线器家用宿舍弱电箱',
                    sharePrice: '188.00',
                    type: '1',
                    title: 'WIFI设备',
                },
                {
                    img: require('@/assets/mifi/32.png'), //首图
                    imga: require('@/assets/mifi/33.png'),//介绍图
                    imgb: require('@/assets/mifi/34.png'),//介绍图
                    shareName: '光猫千兆1分2分线器iptv机顶盒分线盒路由器交换机电脑监控一拖二',
                    sharePrice: '81.00',
                    type: '1',
                    title: 'WIFI设备',
                },
               
                // {
                //     img: require('@/assets/mifi/4.jpg'),
                //     imga: require('@/assets/mifi/4a.jpg'),
                //     imgb: require('@/assets/mifi/4b.jpg'),
                //     type: '2',
                //     shareName: '通用电池模块云厅型号',
                //     sharePrice: '12.99',
                //     title: '设备外设',
                // }
            ],
            active: 0,
            wifiList: [],
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            agentId: '',
            vanTab: ['WIFI设备', '设备外设'],
            allLoaded: false,
            title: 'MIFI设备'
        }
    },
    created() {
        this.wifiList = this.dataList.filter(item => item.type === '1')
    },
    methods: {
        onClick(name, title) {
            this.title = title
            this.pageNo = 0
            this.getAgentPrechargeListHandler()
            this.wifiList = title === 'MIFI设备' ? this.dataList.filter(item => item.type === '1') : this.dataList.filter(item => item.type === '2')
        },
        getAgentPrechargeListHandler() {
            this.$refs.loadmore.onBottomLoaded();
            this.$nextTick(function () {
                window.scroll(0, 0);
            })
        },
        onChange(data) {
            console.log(data)
            if (data === 1) {
                this.$router.push({ path: '/wu/me' });
            }
        },
        linkOpen(data) {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                this.$router.push({ path: '/wu/buyShebeiInfo', query: { p: encodeURI(JSON.stringify(data)) } });
            } else {
                Dialog.confirm({
                    title: "注册提示",
                    message:"请先注册信息后，再进行购买操作。 点击 确定 即可前往注册。"})
                    .then(() => {
                        this.$router.push({ path: '/wu/miBindPhone' });
                    })
                    .catch(() => { });
            }
        }
    }
}
</script>
<style lang="less" scoped>
.body {
    height: auto;
    width: 100%;
    padding-bottom: 163px;
    position: relative;
    .header {
        padding-bottom: 10px;

        img {
            width: 100%;
        }
    }

    // .item-data {
    //     padding: 10px;
    //     height:283px;
    //     img {
    //         width: 100%;
    //         max-height:175px;
    //     }

    //     .goodsTitle {
    //         font-size: 14px;
    //         font-weight: bold;
    //         color: #525253;
    //         line-height: 1.2rem;
    //         height:60px;
    //     }

    //     .goodsPrc {
    //         color: #CB353B;
    //         font-size: 18px;
    //         margin-top: 10px;
    //     }
    // }
    .item-data {
        padding: 10px;

        img {
            width: 100%;
            /* // height:130px; */
            height:190px;
        }

        .goodsTitle {
            font-size: 14px;
            font-weight: bold;
            color: #525253;
            // height: 40px;
            // overflow: hidden;
            // line-height: 1.2rem;


            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            max-height: 3.0em; /* 2行行高的大约值 */
            line-height: 1.5em; /* 这里的行高应与你的实际行高相匹配 */
            white-space: normal;
            word-break: break-all;
        }

        .goodsPrc {
            color: #CB353B;
            font-size: 18px;
            margin-top: 10px;
        }
    }
}

.slecjg {
    width: 138px;
    height: 44px;
    background: #CB353B;
    font-size: 16px;
    color: #fff;
    border-radius: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 20px;
    right: 0;
    left: 0;
    margin: 0 auto;
}

.copyRight {
    position: absolute;
    bottom: 50px;
    left: 0;
    right: 0;
    margin: auto;
}
</style>